import { nullSafeGet } from './DataAccessUtils';
import { ROLE_TYPES } from './DataConstants';

function escapeForMapPopupText(value) {
	if (value == null || value === '') {
		return '';
	}
	return String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

/**
 * HTML string for Mapbox popup on buyer/supplier locations map (Tailwind + design typography classes).
 */
export function buildLocationsMapPopupHtml(record, roleType) {
	const street = nullSafeGet('buyerFacility.primaryAddress.streetAddress1', record);
	const cityLine = [
		nullSafeGet('buyerFacility.primaryAddress.city', record),
		nullSafeGet('buyerFacility.primaryAddress.region', record),
		nullSafeGet('buyerFacility.primaryAddress.postcode', record),
	]
		.filter(Boolean)
		.join(' ');
	/* readLite may omit totalNotClosedWOCount; do not imply "no open WOs" when absent */
	const woCountRaw = nullSafeGet('totalNotClosedWOCount', record);
	const woSummaryBlock =
		typeof woCountRaw === 'number' && !Number.isNaN(woCountRaw)
			? `<div class="footnoteregular text-character-secondary mt-2">${escapeForMapPopupText(
					woCountRaw > 0 ? `${woCountRaw} open work orders` : 'No open work orders'
			  )}</div>`
			: '';
	const isSupplier = roleType === ROLE_TYPES.SUPPLIER;
	const rawId = nullSafeGet('id', record);
	const safeId = escapeForMapPopupText(rawId == null ? '' : String(rawId));
	const detailHref = `${isSupplier ? '/supplier' : '/buyer'}/locations/detail/${safeId}`;
	const linkColorClass = isSupplier ? 'text-supplier' : 'text-buyer';

	return `
			<div class="max-w-[260px] py-0.5">
				<div class="h5medium text-character-primary mb-1.5 leading-snug">${escapeForMapPopupText(
					record.name
				)}</div>
				${
					street
						? `<div class="bodyregular text-character-primary mb-0.5 leading-snug">${escapeForMapPopupText(
								street
						  )}</div>`
						: ''
				}
				${
					cityLine
						? `<div class="bodyregular text-character-secondary mb-0.5 leading-snug">${escapeForMapPopupText(
								cityLine
						  )}</div>`
						: ''
				}
				${woSummaryBlock}
				<a class="bodymedium ${linkColorClass} mt-2.5 inline-block no-underline hover:underline" href="${detailHref}">View location</a>
			</div>
		`;
}
